var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAviationObstructionLightLowIntensity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2381,
    y: 400,
    width: 2079,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2381 -400)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2381,
    y: 400,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2635,
    y: 654,
    width: 1571,
    height: 1571,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2790 1440C2790 1092.06 3072.28 810 3420.5 810 3768.72 810 4051 1092.06 4051 1440 4051 1787.94 3768.72 2070 3420.5 2070 3072.28 2070 2790 1787.94 2790 1440Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2893 1439.5C2893 1150.93 3129.39 917 3421 917 3712.61 917 3949 1150.93 3949 1439.5 3949 1728.07 3712.61 1962 3421 1962 3129.39 1962 2893 1728.07 2893 1439.5Z",
    fill: "#222222",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3000.5 1441.5C3000.5 1210.09 3188.09 1022.5 3419.5 1022.5 3650.91 1022.5 3838.5 1210.09 3838.5 1441.5 3838.5 1672.91 3650.91 1860.5 3419.5 1860.5 3188.09 1860.5 3000.5 1672.91 3000.5 1441.5Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FB4747",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviationObstructionLightLowIntensity);
export default __webpack_public_path__ + "static/media/AviationObstructionLightLowIntensity.291aaffa04ecaacf6b005917edd62534.svg";
export { ForwardRef as ReactComponent };